<template>
  <div class="footer">
    <img src="../assets/images/footer logo.png" alt="" />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.footer {
  width: 100%;
  height: 180px;
  background: #fff4e7;
  position: absolute;
  bottom: 0;
  img {
    width: 320px;
  }
}
</style>